import { brand } from "@/brandVariables/getBandVariables";
import { Box, Text } from "@radix-ui/themes";
import { FC } from "react";

import { ReactComponent as ElgigantenMap } from "../../assets/austria_elgiganten.svg";
import BrickTrack from "../../assets/lego_f1/brick_track_right.png";
import { ClientProps } from "../../../../hooks/useClientData";
import { useTimer } from "../../../../hooks/useCountDown";
import { MapsList } from "../../../../consts/MapsLIst";
import { TimerComp } from "../TimerComp";

export const LeaderboardIsEmpty: FC<{
  clientData: ClientProps;
}> = ({ clientData }) => {
  const MapRender = MapsList["grand oak"];
  const isElgiganten = brand.client === "elgiganten-9u2oj" ? "text-gradient" : "";
  const isElgigantenAlt = brand.client === "elgiganten-9u2oj" ? "elgiganten" : "";

  const { time } = useTimer(clientData.challenge.data?.endDate || undefined);

  const mapToRender = () => {
    if (brand.brand === "logitech" || brand.brand === "legof1") {
      const Map = brand.metaInfo.map;
      return <Map style={{ width: "20rem" }} width={"20rem"} />;
    }

    if (brand.client === "elgiganten-9u2oj") {
      return <ElgigantenMap style={{ width: "20rem" }} width={"20rem"} />;
    } else {
      return <MapRender style={{ width: "20rem" }} width={"20rem"} />;
    }
  };

  return (
    <div className="leaderboard__empty">
      <section className="empty__heading">
        <div className="winner__banner background">
          <div
            className={`background__angle-top-right ${isElgigantenAlt} `}
          ></div>
          <Text size={"6"} as="p">
            Main track details
          </Text>
        </div>
        <div className="heading__timer">
          <TimerComp time={time} />
        </div>
      </section>
      <section className="leaderboard__track-info">
        <div className="track-info">
          <div className="track-info_content">
            <div className="track-info__track">
              <Text as="p" size={"5"}>
                Track
              </Text>
              <Text size={"6"} className={`${isElgiganten}`}>
                {brand.metaInfo.trackName}
              </Text>
            </div>

            <div className="track-info__meta">
              <div>
                {[1, 2].map((key) => {
                  return (
                    <div>
                      <Text as="p">{brand.metaInfo[key].key}</Text>
                      <Text className={`${isElgiganten}`} wrap={"nowrap"}>
                        {brand.metaInfo[key].value}
                      </Text>
                    </div>
                  );
                })}
              </div>

              <div>
                {[3, 4].map((key) => {
                  return (
                    <div>
                      <Text as="p">{brand.metaInfo[key].key}</Text>
                      <Text className={`${isElgiganten}`} wrap={"nowrap"}>
                        {brand.metaInfo[key].value}
                      </Text>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <Box className="track-info__map" m={"auto"} width={"20rem"}>
            {mapToRender()}
          </Box>
        </div>
      </section>
      {brand.brand === "legof1" && (
        <div className="empty__brick-track">
          <img src={BrickTrack} alt="" />
        </div>
      )}
    </div>
  );
};
